import {createStore} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';

import {Container} from '@store/settings/containers/containers.model';

export const containersStore = createStore(
  {name: 'containers'},
  withEntities<Container>(),
  withPagination(),
  withRequestsStatus(),
);